import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import { getTrackPromoBanner } from './tracking';
import { PikPromoBanner } from '../../components/PikPromoBanner';
import { PIK_LANDING_QS } from '../../constants/pikPromoBanner';
import { selectPikPromoBanner } from '../../selectors/pikPromoBanner';
import { selectRegionId } from '../../selectors/selectRegionId';
import { selectIsIndexLandingType } from '../../selectors/landingType';
import { useAppSelector } from '../../types';
import { useApplicationContext } from '../../utils/applicationContext';

export function PikPromoBannerContainer() {
  const { config } = useApplicationContext();
  const regionId = useAppSelector(selectRegionId);
  const pikPromoBanner = useAppSelector(selectPikPromoBanner);
  const isMainPage = useAppSelector(selectIsIndexLandingType);
  const deviceType = useDeviceType();
  const pikRegions = config.get<number[]>('PikPromoRegions') || [];

  if (!isMainPage || !pikRegions.includes(regionId)) {
    return null;
  }

  return (
    <PikPromoBanner
      onClick={getTrackPromoBanner({ label: 'pik', deviceType, queryString: PIK_LANDING_QS })}
      disclaimer={pikPromoBanner.disclaimer}
      hitUrl={pikPromoBanner.hitUrl}
    />
  );
}
